import { createApi } from '@reduxjs/toolkit/query/react';

import { Asset } from 'shared/api/retail';
import { baseQuery } from 'shared/lib/redux';

import { normalizeEntrywaysProgramsAndAppsResponse } from './utils';
import { StaffConfigResponse } from './types';
import { getEntrywaysEndpointUrl } from './constants';

export const entrywaysApi = createApi({
  reducerPath: 'entryways',
  baseQuery: baseQuery(getEntrywaysEndpointUrl),
  endpoints: (builder) => ({
    getUserProgramsAndAppsMES: builder.query<Asset[], void>({
      query: () => ({
        url: 'graphql',
        method: 'POST',
        body: JSON.stringify({
          query: `
        query getUserProgramsAndApps {
            getStaffConfig {
              entrypoint {
                linkUrl
                text
                asset
                openInNewTab
              }
            }
          }
        `,
        }),
      }),
      transformResponse: ({ data }: { data: StaffConfigResponse }) =>
        normalizeEntrywaysProgramsAndAppsResponse(data),
    }),
  }),
});

export const { useGetUserProgramsAndAppsMESQuery } = entrywaysApi;
